// /* eslint-disable no-unused-expressions */
// /* eslint-disable no-param-reassign */
// import { Collapse } from '../../collapsible/js/global';

// export default function _readyToEnrol() {
//     /**
//      * Main wrapper selector.
//      * @type {string}
//      */
//     const RTE_SELECTOR = '[data-component="ready-to-enrol"]';

//     /**
//      * Elements we will be hiding or showing.
//      * @type {string}
//      */
//     // const RTE_GROUP_SECTION = '[data-component="readyToEnrol-section"]';

//     /**
//      * Button firing actions to hide/show elements.
//      * @type {string}
//      */
//     const RTE_TOGGLE_BUTTON = '[data-component="ready-to-enrol-toggle"]';

//     /**
//      * Content class selector.
//      * @type {string}
//      */
//     const RTE_CONTENT = '.ready-to-enrol__select-list';

//     const RTE_DROPDOWN_ITEM_CLASS = '.ready-to-enrol__select-list__item';

//     const RTE_START_BUTTON = '[data-component="start-button"]';

//     const RTE_DROPDOWN_PLACEHOLDER = '[data-component="select-placeholder"]';

//     /**
//      * Class name indicating element is expanded.
//      * @type {string}
//      */
//     const OPEN_CLASS = 'is-expanded';

//     /**
//      * Create a new Aside navigation functionality.
//      * @param {HTMLElement} readyToEnrolNavigation - The wrapping HTML element of the readyToEnrol navigation.
//      * @class
//      */
//     class ReadyToEnrol {
//         constructor(readyToEnrolNavigation) {
//             // Outer wrapper for readyToEnrol.
//             this.readyToEnrolSelection = readyToEnrolNavigation;
//             // Setup collapse to all sections.
//             this.setupCollapse(this.readyToEnrolSelection);
//             // Setup dropdown selection for all items
//             this.setupDropdownSelect(this.readyToEnrolSelection);
//         }

//         /**
//          * Attach instance of Collapse class to each of readyToEnrol menu section.
//          *
//          * @param {object} readyToEnrolSections List of DOM nodes matching menu sections.
//          *
//          * @returns void
//          */
//         setupCollapse(readyToEnrolGroup) {
//             // Get toggle button.
//             const button = readyToEnrolGroup.querySelector(RTE_TOGGLE_BUTTON);
//             const content = readyToEnrolGroup.querySelector(RTE_CONTENT);

//             // Quit if collapse already attached or we are missing toggle  button.
//             if (readyToEnrolGroup.collapse || !button) {
//                 return;
//             }
//             // Attach instance of Collapse to menu section.
//             readyToEnrolGroup.collapse = new Collapse();

//             const { collapse } = readyToEnrolGroup;

//             // Let the collapse whats the name of expanding class.
//             collapse.contentOpenClass = OPEN_CLASS;
//             collapse.buttonActiveClassString = OPEN_CLASS;

//             // Let the collapse know what are the toggle button and content.
//             collapse.collapseButton = button;
//             collapse.collapseContent = content;
//             collapse.collapseWrapper = readyToEnrolGroup;

//             // Attach click listener and callback to toggle button.
//             collapse.collapseButton.addEventListener(
//                 'click',
//                 collapse.toggleOpenState
//             );
//             const isOpen =
//                 collapse.collapseButton.classList.contains(OPEN_CLASS);

//             isOpen ? collapse.openElement() : collapse.closeElement();
//         }

//         setupDropdownSelect(readyToEnrolGroup) {
//             const { collapse } = readyToEnrolGroup;

//             const dropdownItems = readyToEnrolGroup.querySelectorAll(
//                 RTE_DROPDOWN_ITEM_CLASS
//             );

//             const startButton =
//                 readyToEnrolGroup.querySelector(RTE_START_BUTTON);

//             const selectPlaceholder = readyToEnrolGroup.querySelector(
//                 RTE_DROPDOWN_PLACEHOLDER
//             );

//             dropdownItems.forEach((dropdownItem) => {
//                 dropdownItem.addEventListener('click', (dItem) => {
//                     // eslint-disable-next-line no-restricted-globals
//                     event.preventDefault();
//                     try {
//                         // console.log(dItem.srcElement);
//                         // console.log(selectPlaceholder);
//                         startButton.href = dItem.srcElement.dataset.link;
//                         selectPlaceholder.innerHTML =
//                             dItem.srcElement.innerHTML;
//                     } catch (ex) {
//                         console.error(
//                             'missing link for ready to enrol dropdown item'
//                         );
//                     }
//                     // console.log(startButton);
//                     collapse.closeElement();
//                 });
//             });
//         }
//     }

//     const readyToEnrol = document.querySelector(RTE_SELECTOR);

//     if (!readyToEnrol || readyToEnrol.readyToEnrolSelection) {
//         return;
//     }

//     readyToEnrol.readyToEnrolSelection = new ReadyToEnrol(readyToEnrol);
// }

// _readyToEnrol();
